import {
  MASTER_HARDWARE_CATALOG_LIST,
  MASTER_HARDWARE_CATALOG_LIST_SUCCESS,
  MASTER_HARDWARE_CATALOG_LIST_FAILURE,
  MASTER_HARDWARE_CATALOG_CREATE,
  MASTER_HARDWARE_CATALOG_CREATE_SUCCESS,
  MASTER_HARDWARE_CATALOG_CREATE_FAILURE,
  MASTER_HARDWARE_CATALOG_UPDATE,
  MASTER_HARDWARE_CATALOG_UPDATE_SUCCESS,
  MASTER_HARDWARE_CATALOG_UPDATE_FAILURE,
  MASTER_HARDWARE_CATALOG_DELETE,
  MASTER_HARDWARE_CATALOG_DELETE_SUCCESS,
  MASTER_HARDWARE_CATALOG_DELETE_FAILURE,
} from "./actionType";

const initialState = {
  // LIST
  masterHardwareCatalogList: [],
  masterHardwareCatalogListLoading: false,
  masterHardwareCatalogListError: null,

  // CREATE
  masterHardwareCatalogCreate: {},
  masterHardwareCatalogCreateLoading: false,
  masterHardwareCatalogCreateError: null,

  // UPDATE
  masterHardwareCatalogUpdate: {},
  masterHardwareCatalogUpdateLoading: false,
  masterHardwareCatalogUpdateError: null,

  // DELETE
  masterHardwareCatalogDelete: {},
  masterHardwareCatalogDeleteLoading: false,
  masterHardwareCatalogDeleteError: null,
};

const masterReducer = (state = initialState, action) => {
  switch (action.type) {
    // LIST
    case MASTER_HARDWARE_CATALOG_LIST:
      return {
        ...state,
        masterHardwareCatalogListLoading: true,
        masterHardwareCatalogListError: null,
      };

    case MASTER_HARDWARE_CATALOG_LIST_SUCCESS:
      return {
        ...state,
        masterHardwareCatalogList: action.payload,
        masterHardwareCatalogListLoading: false,
      };

    case MASTER_HARDWARE_CATALOG_LIST_FAILURE:
      return {
        ...state,
        masterHardwareCatalogListLoading: false,
        masterHardwareCatalogListError: action.payload,
      };

    // CREATE
    case MASTER_HARDWARE_CATALOG_CREATE:
      return {
        ...state,
        masterHardwareCatalogCreateLoading: true,
        masterHardwareCatalogCreateError: null,
      };

    case MASTER_HARDWARE_CATALOG_CREATE_SUCCESS:
      return {
        ...state,
        masterHardwareCatalogCreate: action.payload,
        masterHardwareCatalogCreateLoading: false,
      };

    case MASTER_HARDWARE_CATALOG_CREATE_FAILURE:
      return {
        ...state,
        masterHardwareCatalogCreateLoading: false,
        masterHardwareCatalogCreateError: action.payload,
      };

    // UPDATE
    case MASTER_HARDWARE_CATALOG_UPDATE:
      return {
        ...state,
        masterHardwareCatalogUpdateLoading: true,
        masterHardwareCatalogUpdateError: null,
      };

    case MASTER_HARDWARE_CATALOG_UPDATE_SUCCESS:
      return {
        ...state,
        masterHardwareCatalogUpdate: action.payload,
        masterHardwareCatalogUpdateLoading: false,
      };

    case MASTER_HARDWARE_CATALOG_UPDATE_FAILURE:
      return {
        ...state,
        masterHardwareCatalogUpdateLoading: false,
        masterHardwareCatalogUpdateError: action.payload,
      };

    // DELETE
    case MASTER_HARDWARE_CATALOG_DELETE:
      return {
        ...state,
        masterHardwareCatalogDeleteLoading: true,
        masterHardwareCatalogDeleteError: null,
      };

    case MASTER_HARDWARE_CATALOG_DELETE_SUCCESS:
      return {
        ...state,
        masterHardwareCatalogDelete: action.payload,
        masterHardwareCatalogDeleteLoading: false,
      };

    case MASTER_HARDWARE_CATALOG_DELETE_FAILURE:
      return {
        ...state,
        masterHardwareCatalogDeleteLoading: false,
        masterHardwareCatalogDeleteError: action.payload,
      };

    default:
      return state;
  }
};

export default masterReducer;